export default "__VITE_ASSET__7867a19c__"